var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Projects',{attrs:{"error":_vm.error,"projects":_vm.projects,"api":_vm.api,"projects_length":_vm.projects.length}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }